<template>
    <div style="height: 100%">
        <!--                <data-table model="App\Customer"></data-table>-->
        <!--        Header Beginner-->
        <v-toolbar flat color="transparent">
            <v-toolbar-title>Stores</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="mx-3 fl">
                <download-excel class="btn btn-default" :data="rows" :fields="json_fields" worksheet="Stores"
                    :name="fileName" :before-generate="exportStores">
                    <v-btn color="primary">Export Stores</v-btn>
                </download-excel>
            </div>
            <div v-if="[1, 2, 4].includes(role)" class="mx-3 fl">
                <b-button @click="uuid = null; dataForm = true" variant="outline-primary">Add Store</b-button>
            </div>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line clearable hide-details
                :style="{ 'max-width': ($vuetify.breakpoint.xs) ? '135px' : '320px' }"></v-text-field>
        </v-toolbar>
        <!--        Header End-->
        <v-data-table :mobile-breakpoint="0" class="mb-5" v-model="selected" :headers="headers" :items="rows"
            :loading="loading" loading-text="Loading... Please wait" :search="search" item-key="uuid"
            :options.sync="options" :show-select="settings.select_all" footer-props.prev-icon="arrow_left"
            footer-props.next-icon="arrow_right" header-props.sort-icon="arrow_drop_down"
            :items-per-page="options.itemsPerPage" @page-count="pageCount = $event" hide-default-footer
            :page.sync="options.page">

            <template :slot="'item.' + item.value" slot-scope="props" v-for="(item, index) in headers">
                <div v-if="index != Object.keys(headers).length - 1 || !settings.actions" :style="item.style">
                    <div v-if="item.type === 'boolean'" class="text-xs-center">
                        <div v-if="props.item[item.value] === 1 || props.item[item.value] === '1'">
                            <v-icon small>check</v-icon>
                        </div>
                        <div v-else>
                            <v-icon small>close</v-icon>
                        </div>
                    </div>
                    <div v-else-if="item.type === 'link'">
                        <a :href="props.item[item.value]" target="_blank">{{
                            props.item[item.value].replace('http://', '').replace('https://', '').replace('//', '')
                        }}</a>
                    </div>
                    <div v-else-if="item.type === 'campaign_link'">
                        <a :href="props.item[item.value] + '/staff'" target="_blank" style="font-weight: bold">Staff
                            Area</a> | <a :href="props.item[item.value]" target="_blank">{{
                                props.item[item.value].replace('http://', '').replace('https://', '').replace('//', '')
                            }}</a>
                    </div>
                    <div v-else-if="item.type === 'number' || item.type === 'currency'">
                        <div class="text-xs-right">{{ props.item[item.value] }}</div>
                    </div>
                    <div v-else-if="item.type === 'date_time'">
                        <span
                            v-html="parseDateTime(props.item[item.value], item.format, item.color_is_past, item.color_is_future)"></span>
                    </div>
                    <div v-else-if="item.type === 'image'">
                        <v-img :src="props.item[item.value]" class="elevation-1 my-3 d-block" v-if="props.item[item.value]"
                            contain :max-width="item.max_width" :max-height="item.max_height"></v-img>
                    </div>
                    <div v-if="item.value === 'avatar'" class="text-xs-center">
                        <v-avatar :tile="false" size="32" color="grey lighten-4">
                            <v-img :src="props.item[item.value]" v-if="props.item[item.value]"></v-img>
                        </v-avatar>
                    </div>
                    <div v-else>
                        <span>{{ props.item[item.value] }}</span>
                    </div>
                </div>
                <div v-if="index == Object.keys(headers).length - 1 && settings.actions">
                    <div class="action-menu-wrapper d-flex">
                        <span v-for="(item, index) in actions">
                            <v-tooltip top v-if="item.action">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mr-1 mt-0 mb-0" v-on="on" :dark="item.dark" :color="item.color" icon small
                                        @click="executeAction(item.action, props.item.uuid)">
                                        <v-icon small>{{ item.icon }}</v-icon></v-btn>
                                </template>
                                <span>{{ item.text }}</span>
                            </v-tooltip>
                            <v-divider v-else vertical class="grey lighten-2" style="vertical-align: middle;"></v-divider>
                        </span>
                    </div>
                </div>
            </template>

            <template v-slot:footer>
                <v-row>
                    <v-col :cols="8">
                        <div v-if="[1, 2, 4].includes(role)" class="ma-3">
                            <v-btn v-if="settings.select_all" depressed small color="error"
                                :disabled="disableDeleteSelected" @click="deleteSelected">{{ $t('delete_selected') }}
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col :cols="2">
                        <v-select :items="itemsPerPageOptions" v-model="options.itemsPerPage"
                            label="Rows per page"></v-select>
                    </v-col>
                    <v-col :cols="2">
                        <v-pagination v-model="options.page" :length="pageCount" :total-visible="7"></v-pagination>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:no-data>
                <div v-if="!loading" class="text-xs-center">
                    Your search and/or filter found no results.
                </div>
                <div v-if="loading" class="text-xs-center">
                    Loading data
                </div>
            </template>

        </v-data-table>
        <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly"
            v-model="dataForm" :dataForm="dataForm" @keydown.esc="dataForm = false">
            <data-form v-if="dataForm" v-on:data-list-events="dataListEvents($event)" :model="model"
                :uuid="uuid" :readonly="readonly"></data-form>
        </v-dialog>
    </div>
</template>
<script>
import _ from "lodash";

export default {
    data() {
        let actions_form = [{
            action: "view",
            color: "secondary",
            dark: false,
            icon: "visibility",
            text: "View",
        }];
        this.readonly = true;
        if ([1, 2, 4].includes(this.$auth.user().role)) {
            this.readonly = false;
            actions_form.push(
                {
                    action: "edit",
                    color: "secondary",
                    dark: false,
                    icon: "edit",
                    text: "Edit",
                },
                {
                    action: "delete",
                    color: "secondary",
                    dark: true,
                    icon: "delete",
                    text: "Delete",
                },);
        }
        return {
            role: this.$auth.user().role,
            model: "Platform\\Models\\Location",
            loading: true,
            disableDeleteSelected: true,
            search: '',
            openMenu: [],
            selected: [],
            settings: {
                actions: true,
                actions_width: "100px",
                create: true,
                select_all: true,
            },
            dataForm: false,
            actions: actions_form,
            translations: [],
            rows: [],
            filters: {},
            options: {
                page: 1,
                itemsPerPage: 10,
                filters: []
            },
            pageCount: 0,
            itemsPerPageOptions: [10, 25, 50, 75, 100],
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    value: 'name',
                },
                {
                    text: 'Brand',
                    align: 'left',
                    value: 'business',
                },
                {
                    text: 'Program',
                    align: 'left',
                    value: 'program',
                },
                {
                    text: 'Country',
                    align: 'left',
                    value: 'country',
                },
                {
                    text: 'Region',
                    align: 'left',
                    value: 'region',
                },
                {
                    text: 'City',
                    align: 'left',
                    value: 'city',
                },
                {
                    text: 'E-mail',
                    align: 'left',
                    value: 'email',
                },
                {
                    text: 'Actions',
                    align: 'center',
                    sortable: false,
                    value: 'actions',
                    class: "d-flex justify-center",
                },
            ],
        }
    },
    created() {
        this.getLocations()
    },
    computed: {
        app() {
            return this.$store.getters.app
        }
    },
    watch: {
        selected() {
            this.disableDeleteSelected = (this.selected.length > 0) ? false : true;
        }
    },
    methods: {
        exportStores() {
            const sort_by = (property, desc) => {
                let sortOrder = desc ? -1 : 1;
                return function (a, b) {
                    /* next line works with strings and numbers,
                     * and you may want to customize it to your needs
                     */
                    let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            }
            this.rows.sort(sort_by(this.options.sortBy[0], this.options.sortDesc[0]));
        },
        dataListEvents(event) {
            if (event.closeDialog) {
                this.dataForm = false
            }
            if (event.reload) {
                this.getLocations()
            }
        },
        getLocations() {
            this.loading = true
            const params = this.filters;
            axios.get('/stores', { params })
                .then(res => {
                    this.rows = res.data
                    this.loading = false
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false)
        },
        deleteSelected() {
            if (this.selected.length > 0) {
                let uuids = this.selected
                uuids = _.map(uuids, function (o) {
                    return o.uuid;
                });
                this.deleteRecords(uuids)
            }
        },
        openMenuToogle(index) {
            for (var i in this.openMenu) {
                if (i !== index) {
                    this.$set(this.openMenu, i, false);
                }
            }

            if (!this.openMenu[index]) {
                this.$set(this.openMenu, index, true);
            } else {
                this.$set(this.openMenu, index, false);
            }
            // this.openMenu[index] = !this.openMenu[index];
        },
        executeAction(action, uuid) {
            if (action === 'delete') {
                this.uuid = null
                this.deleteRecords([uuid])
            }
            if (action === 'link') {
                this.uuid = uuid;
                this.$router.push({ name: 'customer.profile', params: { uuid: this.uuid } })
            }
            if (action === 'edit' || action === 'view') {
                this.uuid = uuid
                this.dataForm = true
            }
        },
        deleteRecords(uuids) {
            this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                    if (confirm) {
                        axios.post('/app/data-table/delete', {
                            locale: this.$i18n.locale,
                            model: this.model,
                            uuids: uuids
                        })
                            .then(res => {
                                if (res.data.status === 'success') {
                                    this.getLocations()
                                    this.$root.$snackbar(this.$t('items_deleted', { items: res.data.deleted }))
                                }
                            })
                            .catch(err => {
                                if (err.response.data.status === 'error') {
                                    this.$root.$snackbar(err.response.data.msg)
                                    this.reloadData()
                                }
                            })
                            .finally(() => this.loading = false)
                    }
                })
        },
    }
}
</script>
